module.exports = __webpack_public_path__ + "static/img/mu.896330b7.svg";